var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenlightinnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.67 36.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5f6062;}.b{fill:#80bc00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50.2,9.14a6.285,6.285,0,0,0-2.5-.51A3.3,3.3,0,0,0,44.181,11.7a3.147,3.147,0,0,0,0,.445A3.211,3.211,0,0,0,47.118,15.6a3.12,3.12,0,0,0,.362.009,5.459,5.459,0,0,0,1.28-.14V12.94H46.7V11.39h3.92v5.23a12.649,12.649,0,0,1-3.14.5c-3.14,0-5.33-1.57-5.33-4.86s2-5.18,5.33-5.18a9.545,9.545,0,0,1,2.85.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.7,7.26h2.14c2.09,0,4.57-.07,4.57,2.63a2.211,2.211,0,0,1-2,2.25h0c.53,0,.84.57,1,1l1.56,3.8H59.84l-1.17-3c-.28-.72-.53-1-1.35-1H56.7v4h-2Zm2,4.15h.64c1,0,2-.14,2-1.35s-1.08-1.27-2-1.27H56.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.41,7.26h5.73V8.79H67.36v2.4h3.48v1.53H67.36v2.72h3.81v1.53H65.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M75.15,7.26h5.69V8.79H77.1v2.4h3.46v1.53H77.1v2.72h3.81v1.53H75.15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M84.84,7.26h2.4l3.7,7.26h0V7.26h1.9v9.71H90.45L86.74,9.71h0v7.26h-1.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M97.1,7.26h1v8.88h3.89v.83H97.14Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M105.38,7.26h1v9.71h-1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M117.3,12.55h-2.25v-.84h3.21v4.83a7.232,7.232,0,0,1-3,.6c-3.06,0-4.9-2-4.9-5a4.683,4.683,0,0,1,4.9-5,6.758,6.758,0,0,1,2.6.46l-.11.89a5.132,5.132,0,0,0-2.49-.52c-2.52,0-3.94,1.78-3.94,4.19s1.38,4.18,3.94,4.18a4.987,4.987,0,0,0,2-.34Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M122.69,7.26h1v4.3h4.91V7.26h1v9.71h-1V12.39h-4.91v4.58h-1Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M135.84,8.1h-2.86V7.26h6.69V8.1h-2.83v8.87h-1Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.13,24.97h.86v6.57h-.86Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.12,24.97h1.09l4.45,5.78h0V24.97h.86v6.57H54.39l-4.38-5.66h0v5.66h-.87Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.72,24.97h1.12l4.45,5.78h0V24.97h.87v6.57H65.98l-4.37-5.66h0v5.66h-.86Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M75.84,24.86c2.63,0,3.87,1.62,3.85,3.4,0,2-1.33,3.39-3.85,3.39s-3.82-1.38-3.85-3.39C71.92,26.48,73.17,24.86,75.84,24.86Zm-3,3.4a3,3,0,1,0,3.127-2.867c-.042,0-.085,0-.127,0a2.77,2.77,0,0,0-2.992,2.528A2.6,2.6,0,0,0,72.84,28.26Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.39,31.54h-.93l-3.25-6.57h.91l2.82,5.92,2.9-5.92h.85Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.91,24.97h1l3.47,6.57h-.9l-.94-1.76H95.13l-.94,1.76h-.84Zm.43.62-1.91,3.62h3.8Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M106.52,25.54h-2.58v-.57h6v.57h-2.58v6h-.87Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.24,24.97h.87v6.57h-.87Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M123.75,24.86c2.63,0,3.88,1.62,3.85,3.4,0,2-1.33,3.39-3.85,3.39s-3.82-1.38-3.85-3.39C119.84,26.48,121.12,24.86,123.75,24.86Zm-3,3.4a3,3,0,1,0,3.156-2.836c-.052,0-.1,0-.156,0a2.771,2.771,0,0,0-2.98,2.84Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M132.4,24.97h1.09l4.45,5.78h0V24.97h.9v6.57h-1.16l-4.38-5.66h0v5.66h-.87Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 43.01,
    y: 20.97,
    width: 95.84,
    height: 0.35
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,18.39a18.42,18.42,0,0,0,36.84,0,18.809,18.809,0,0,0-.15-2.25l-5.25,3.67-.1-.15-1.7-2.58L11.77,29.59a11.8,11.8,0,0,1-1.19-.79L28.95,15.93l-2-2.62L8.21,26.47a11.983,11.983,0,0,1-.78-1.08L26.24,12.22,24.36,9.54,6.01,22.39a12.66,12.66,0,0,1-.36-1.38l18-12.56L21.77,5.77l5.17-3.65A18.172,18.172,0,0,0,18.41,0,18.421,18.421,0,0,0,0,18.39ZM15.39,31.05,31.31,19.9a2.2,2.2,0,0,1-.09.76A13,13,0,0,1,16.175,31.226l-.035-.006A6.005,6.005,0,0,1,15.39,31.05ZM5.46,17.16a5.469,5.469,0,0,1,.12-1A13,13,0,0,1,20.609,5.571l.051.009c.34.06.67.15,1,.23Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.84,14.61l4.65-3.4c.19.42.35.85.5,1.28L31.18,16A11.268,11.268,0,0,0,30.84,14.61Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.24,7.32l4.77-3.49a11.051,11.051,0,0,1,1,.91L26.37,8.13A13.594,13.594,0,0,0,25.24,7.32Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.74,10.49,33.2,7.22c.27.35.52.72.76,1.09L29.5,11.59A10.241,10.241,0,0,0,28.74,10.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenlightinnovation);
export default __webpack_public_path__ + "static/media/greenlightinnovation.18a3b09a1abd97ef83e3ecde493db668.svg";
export { ForwardRef as ReactComponent };